import { useLanguage } from "@/lib/i18n";

/**
 * Given a service object (with optional `name_en` and `description_en`),
 * return the correct `name` and `description` for the active language.
 * Falls back to the German source if the English version is empty.
 */
export function useLocalizedService() {
  const { lang } = useLanguage();
  return (svc) => {
    if (!svc) return svc;
    if (lang !== "en") return svc;
    const name = svc.name_en && svc.name_en.trim() ? svc.name_en : svc.name;
    const description =
      svc.description_en && svc.description_en.trim()
        ? svc.description_en
        : svc.description;
    return { ...svc, name, description };
  };
}
